import React from 'react';
import { connect } from 'react-redux';
import { compose, lifecycle, withHandlers } from 'recompose';
import { ModalBody, ModalHeader, ModalFooter } from 'reactstrap';
import { ENTER_KEY_NAME, ESCAPE_KEY_NAME } from '@mm/constants/keys-codes';
import Button from '../../buttons/DeprecatedButton/DeprecatedButton';
import './RemoveUserModal.scss';

import UsersCRUDActions from '@mm/state/actions/UsersCRUDActions';


const RemoveUserModal = (props) => {
  const { company, user, closeModal, onRemoveUser } = props;
  return (
    <div>
      <ModalHeader className="remove-user-modal__header">
        Remove a user
      </ModalHeader>
      <ModalBody className="remove-user-modal__body">
        <div className="remove-user-modal__text">
          Are you sure you want to remove&nbsp;
          {user && user.lastName} {user && user.firstName} from {company && company.name}?
        </div>
      </ModalBody>
      <ModalFooter className="remove-user-modal__footer">
        <Button
          red
          invert
          small
          onClick={closeModal}
        >
          Cancel
        </Button>
        <Button
          onClick={onRemoveUser}
          small
        >
          Remove
        </Button>
      </ModalFooter>
    </div>
  )
}

const onRemoveUser = ({ user, deleteUser, company, closeModal }) => () => {
  deleteUser(company.id, user.id);

  closeModal()
}

const mapDispatchToProps = dispatch => ({
  deleteUser: (companyId, userId) => dispatch(UsersCRUDActions.delete(companyId, userId)),
});

function componentWillMount() {
  document.addEventListener('keydown', this.props.onKeyDown);
}

function componentWillUnmount() {
  document.removeEventListener('keydown', this.props.onKeyDown);
}

const onKeyDown = ({ onRemoveUser, closeModal }) => e => {
  if (e.key === ENTER_KEY_NAME) {
    onRemoveUser();
  } else if (e.key === ESCAPE_KEY_NAME) {
    closeModal();
  }
};

const enhance = compose(
  connect(null, mapDispatchToProps),
  withHandlers({ onRemoveUser }),
  withHandlers({ onKeyDown }),
  lifecycle({ componentWillMount, componentWillUnmount }),
);

export default enhance(RemoveUserModal);
